<template>
  <v-app>

    <portal-sysbar></portal-sysbar>

    <div class="main-content">

      <portal-aside></portal-aside>

      <portal-title :title="$t('message.aside.infoloc', { value: 'default' })"></portal-title>

      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete :items="ecmList"  outlined dense hide-details solo item-value="company"
              item-text="name" label="ECM"  @change="filterByEcm"></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete v-model="assetId" :items="assetList" item-value="asset" 
            item-text="asset" :label="$t('message.infoloc.locomotive', { value: 'default' })"
              outlined dense hide-details solo @change="loadData"></v-autocomplete>
          </v-col>


        </v-row>

        <h1>
          <span>{{
            $t("message.infoloc.locomotive", { value: "default" })
          }}</span>
          : {{ asset?.asset?.assetnum }}
        </h1>
        <v-row>
          <v-col>
            <v-chip v-if="this.lastKM" dark :color="getColor()" @click="goToHistory('kmHistory')"
              style="text-transform: uppercase">
              {{ formatdate(lastKM.readingdate) }} : {{ lastKM.reading }} KM

            </v-chip>
          </v-col>
          <v-col>
            <v-chip v-if="this.lastHM" dark :color="getColor()" @click="goToHistory('hmHistory')"
              style="text-transform: uppercase">
              {{ formatdate(lastHM.readingdate) }} : {{ lastHM.reading }} HM

            </v-chip>
          </v-col>
        </v-row>
        <locomotive-data
          :asset="asset"
          :workorder="workorder"
          :homologations="homologations"
          :pleft="pleft"
          :calcduedate="calcduedate"
          :remark="remark"
        />

        <locomotive-history
          :srs="srs"
          :km-datas="meterKMdatas"
          :hm-datas="meterHMdatas"
        />

        <wheelset
          :wheelsets="wheelsets"
          :wheelsets-nums="wheelsetsNums"
        />

      </div>
      <!-- loader-->
      <portal-loading :show="loading"></portal-loading>

      <!-- sign dialog-->

      <!-- measurement dialog (unused) -->
      <v-dialog v-model="showWheel" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
        <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
          <v-system-bar height="30" color="#fff" class="px-0 mb-3">
            <span></span>
            <v-spacer></v-spacer>
            <v-icon size="32" class="pt-5" @click="showWheel = false">mdi-close</v-icon>
          </v-system-bar>
          <v-row>
            <v-col>
              <div>
                <span class="mtitle">
                  Wheelset measurements
                </span>
              </div>
              <v-data-table dense :headers="headersProtocol" :items="wheelmeasurements" light>
                <template v-slot:[`item.createdate`]="{ item }">
                  {{ formatdate(item.createdate) }}
                </template>
                <template v-slot:[`item.document`]="{ item }" @click="downloadProtocol(item)">
                  {{ item.documentName }}

                  <v-icon @click="downloadProtocol(item)"> mdi-download</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

    </div>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import LocomotiveData from "@/components/locomotiveData/LocomotiveData.vue";
import LocomotiveHistory from "@/components/locomotiveData/LocomotiveHistory.vue";
import Wheelset from "@/components/locomotiveData/Wheelset.vue";
import PortalLoading from "@/components/PortalLoading.vue";
import { formatMagicDate, getDefaultPeriod } from "@/shared/DateHelper";
import MaximoService from "@/services/MaximoService";

export default {
  watch: {
    getterCurrentClient() {
      this.initAssetList();
    },
  },
  methods: {
    ...mapActions("carpet", {
      actionGetAssets: "loadAssets"
    }),

    async initAssetList() {
      await this.actionGetAssets({
          customer: this.getterCurrentClient, 
          start:getDefaultPeriod().start, 
          end: getDefaultPeriod().end 
    });
      this.assetReferential = this.getterAssets.filter(elt => (elt.leasedState == "leased"));
      this.assetList = this.assetReferential;
      this.assetList.forEach(a => {
        if([
      "MGW000",
      "MGWF",
      "MGWF-1",
      "AKIEM SAS",
      "MGWHU"
        ].includes(a.ecmCode)){
          a.ecmName = "AKIEM MAINTENANCE & SERVICES";
        }
      });

      this.ecmList = this.assetList.map(a => ({
        company: a.ecmCode,
        name: a.ecmName
      }));
    },

    filterByEcm(value) {
      this.assetList = this.assetReferential.filter((item) => item.ecmCode == value)
    },

    async showMeasurementDetails(id) {
      await MaximoService.getDoclinksWheelset(id)
        .then((response) => {
          this.wheelmeasurements = response.data;
          this.showWheelmeasurements = true;
        })
        .catch(() => {
          this.wheelmeasurements = [];
          this.showWheelmeasurements = false;
        });
      this.showWheel = true;
    },

    getMemo(asset) {
      if (this.status.includes(asset.status)) {
        MaximoService.getStatusMemo(asset.assetid, asset.status).then(
          (response) => {
            this.remark = response.data.memo;
            this.loading = false
          }
        ).catch(() => {
          this.loading = false
        });
      } else {
        this.remark = "";
      }
    },
    async getAsset(assetnum) {
      this.loading = true
      MaximoService.getAssetByAssetnum(assetnum).then((response) => {
        this.asset = response.data;
        if (this.asset.workorder != null) {
          this.workorder = this.asset.workorder;
          this.workorder.location = this.workorder.location?.location;
        }
        this.getMemo(this.asset.asset);
      });
    },

    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },

    getNextMaintenancePlan(assetnum) {
      MaximoService.getNextMaintenancePlan(assetnum).then((response) => {
        this.calcduedate = response.data.calcduedate;
        this.pleft = response.data.pleft;
      }).catch(() => {
        this.calcduedate = "";
        this.pleft = "";
      });
    },

    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },

    getWheelsetMeasurement(assetnum) {
      MaximoService.getWheelsetMeasureDates(assetnum).then(({ data }) => {
        this.wheelsets = data ? data : [];
        //this.getWheelsetsDoclinks();
      }).catch(() => {
        this.wheelsets = [];
      });
    },

    getWheelsetsDoclinks() {
      MaximoService.getDoclinksWheelsets(this.wheelsets.map(w => w.measures[0].measures[0].workorderid).filter(w => w != null)).then((response) => {
        this.wheelsetsDoclinks = response.data;
      }).catch(() => {
        this.wheelsetsDoclinks = [];
      });
    },

    buildItems(data) {
      data.forEach((item) => {
        this.items.push({
          step: item.plusc,
          info: item.description,
        });
      });
    },

    getMeterdatas(assetnum) {
      MaximoService.getMeterdataByAsset(assetnum).then((response) => {
        this.meterKMdatas = response.data.filter(m => m.metername == "MILEAGE");
        this.meterHMdatas = response.data.filter(m => m.metername == "H0URS");
      });
    },
    getLastHM(assetnum) {
      MaximoService.getLastMeter(assetnum, "H0URS").then((response) => {
        this.lastHM = response.data;
      });
    },
    getLastKM(assetnum) {
      MaximoService.getLastMeter(assetnum, "MILEAGE").then((response) => {
        this.lastKM = response.data;
      });
    },
    getColor() {
      return "#00475a";
    },
    goToHistory(ref) {
      this.$refs[ref].$el.scrollIntoView();
    },
    getPmWorkorders(assetnum) {
      MaximoService.getAssetPMWorkorders(assetnum).then((response) => {
        this.buildItems(response.data);
      });
    },
    getHomologations(assetnum) {
      MaximoService.getAssetHomologation(assetnum).then((response) => {
        this.homologations = response.data;
      });
    },

    getOpenSr(assetnum) {
      let scope = "internal";
      if (this.getterContact.internal) {
        scope = "internal";
      } else {
        scope = "external";
      }
      MaximoService.getOpenSrByAsset(scope, assetnum).then((response) => {
        this.srs = response.data;
      });
    },

    getWorkorder(assetnum) {
      MaximoService.getLastWorkorderByAssetnum(assetnum).then((response) => {
        this.workorder = response.data;
        MaximoService.getLocation(this.workorder.location).then((response) => [
          (this.asset.location = response.data.description),
        ]);
      });
    },
    getWheelSet(assetnum) {
      MaximoService.getWheelsets(assetnum).then(response => {
        this.wheelsetsNums = response.data
      }).catch(() => {
        this.wheelsetsNums = []
      })
    },

    loadData() {
      this.loading = true
      this.getAsset(this.assetId);
      this.getNextMaintenancePlan(this.assetId);
      this.getOpenSr(this.assetId);
      this.getHomologations(this.assetId);
      this.getWheelSet(this.assetId)
      this.getWheelsetMeasurement(this.assetId);
      this.getPmWorkorders(this.assetId);
      this.getMeterdatas(this.assetId);
      this.getLastHM(this.assetId);
      this.getLastKM(this.assetId);
      this.loading = false
    }
  },
  mounted() {
    this.assetId = this.$route.params.asset
    this.initAssetList();
    if (this.assetId != undefined) {
      this.loadData()
    }

  },
  data() {
    return {
      assetId: null,
      asset: null,
      assetReferential: [],
      assetList: [],
      ecmList: [],
      remark: "",
      loading: false,
      status: ["CONDREL", "BLOCKED"],
      calcduedate: "",
      pleft: "",
      search: "",
      srs: [],
      wheelsets: [],
      wheelsetsNums: [],
      wheelsetsDoclinks: [],
      wheelmeasurements: [],
      showWheelmeasurements: false,
      showWheel: false,
      items: [],
      homologations: [],
      meterHMdatas: [],
      meterKMdatas: [],
      workorder: {
        description: "--",
        targcompdate: "--",
        remarks: "--",
      },
      lastHM: false,
      lastKM: false,
    };
  },
  title: "",
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    PortalLoading,
    LocomotiveData,
    LocomotiveHistory,
    Wheelset,
  },
  computed: {
    headersProtocol() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "createdate",
      },
      {
        text: this.$t("message.magic.details", { value: "default" }),
        value: "document",
      },
      ];
    },

    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),

    ...mapGetters("carpet", {
      getterAssets: "getAssets"
    })
  }
};
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.portal-deep-blue-bg {
  padding: 5px 0px 5px 10px;
  color: #fff;
  text-transform: uppercase;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>th.shrink {
    white-space:nowrap;
}

.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background-color: #c4c7c9;
  font-weight: bolder;
  color: #00475a;
  text-align: center;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  text-align: center;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 14px;
}

.value {
  font-size: 16px;
}

.display-wheel {
  display: flex !important;
  justify-content: flex-start;
  align-items: baseline;
}

.schema-text {
  font-size: 10px;
}

.wheel {
  position: absolute;
  height: 200px;
  width: 300px;
}
</style>
